import {
  NoteType,
  ShipmentLineItemStatus,
} from "../../../utils/constants";

/**
 * Auto-created shipment line item for truck-to-rail outbound (same fields as
 * dev `PlacedShipmentCard` `doCreateShipmentLineItem`). `quantityReceived` is not
 * on the InventoryItem GraphQL type unless denormalized on the client; fall
 * back to `quantityOnHand`.
 */
export const buildAutoCreatedShipmentLineItem = ({
  inventory,
  inventoryItem,
  currentUserName,
}) => ({
  active: inventory.active,
  status: ShipmentLineItemStatus.PENDING,
  groups: inventory.groups,
  totalQuantityToPick:
    inventoryItem.quantityReceived ?? inventoryItem.quantityOnHand,
  outboundShipmentId: inventoryItem.outboundShipmentId,
  reloadYardId: inventory.reloadYardId,
  inventoryId: inventory.id,
  accountId: inventory.accountId,
  lotNumber: inventory.lotNumber,
  history: [
    {
      type: NoteType.INVENTORY,
      date: new Date(),
      by: currentUserName,
      text: "Pick List item auto-generated",
    },
  ],
  sortKey: 10001,
});
